
import { IDatabase, ICollectionReference, IDocumentReference, DocumentData, WhereFilterOp, OrderByDirection, IQuery, IDocumentSnapshot, IGetOptions, SnapshotListenOptions, IQuerySnapshot, UpdateData, ISnapshotOptions, FieldPath, ISnapshotMetadata, IDocumentChange, ISetOptions } from '../IDatabase';

import { QueryOperation, ChangeListener, IChangeSnapshot } from './http-mongo';
import { WebApiConnectionService } from "./WebApiConnectionService";




export namespace MongoCast {


    export class LottolocaMongoDb implements IDatabase {

        constructor(private http: WebApiConnectionService) {

        }

        collection(path: string): ICollectionReference {


            return new CollectionReference(path, this.http);
        }


    }



    export class SnapshotMetadata implements ISnapshotMetadata {
        hasPendingWrites: boolean; fromCache: boolean;
        isEqual(other: ISnapshotMetadata): boolean {
            throw new Error("Method not implemented.");
        }


    }

    export class DocumentSnapshot implements IDocumentSnapshot {



        constructor(private _documentData: DocumentData) {
            if (!this.exists) {
                this._documentData = null;
            }
        }

        get exists(): boolean {
            return this._documentData != null && this._documentData["_id"] != null;
        }

        get ref(): IDocumentReference {
            throw new Error("Method not implemented.  DocumentSnapshot");
        }

        get id(): string {

            if (this._documentData != null) {
                return this._documentData.id;
            }
            return null;
        }

        get metadata(): ISnapshotMetadata {
            throw new Error("Method not implemented.  DocumentSnapshot");
        }

        data(options?: ISnapshotOptions): DocumentData {
            return this._documentData;
            //corrigir
        }
        get(fieldPath: string | FieldPath, options?: ISnapshotOptions) {
            throw new Error("Method not implemented.  DocumentSnapshot");
        }
        isEqual(other: IDocumentSnapshot): boolean {
            throw new Error("Method not implemented.  DocumentSnapshot");
        }


    }

    export class QuerySnapshot implements IQuerySnapshot {

        private _docs: DocumentSnapshot[];

        constructor(docs: DocumentData[]) {



            if (docs != null) {
                this._docs = docs.map(x => new DocumentSnapshot(x));
            }
            else {
                this._docs = [];
            }
        }

        get query(): IQuery {
            throw new Error("Method not implemented.  QuerySnapshot");
        }
        get metadata(): ISnapshotMetadata {
            throw new Error("Method not implemented.  QuerySnapshot");
        }
        get docs(): IDocumentSnapshot[] {
            return this._docs;
        }
        get size(): number {
            return this._docs.length;
        }
        get empty(): boolean {
            throw new Error("Method not implemented.  QuerySnapshot");
        }
        docChanges(options?: SnapshotListenOptions): IDocumentChange[] {
            throw new Error("Method not implemented.  QuerySnapshot");
        }
        forEach(callback: (result: IDocumentSnapshot) => void, thisArg?: any): void {

            //arrumar talvez
            this._docs.forEach(item => {
                callback(item);
            });


        }
        isEqual(other: IQuerySnapshot): boolean {
            throw new Error("Method not implemented.  QuerySnapshot");
        }




    }



    export class Query implements IQuery {


        public queryOperations: QueryOperation[] = [];
        _documentData: DocumentData[];
        _previousFinalDocumentData: any[];
        _previousChanges: IChangeSnapshot[] = [];

        constructor(public path: string, queryOperations: QueryOperation[], protected httpMongo: WebApiConnectionService) {

            if (queryOperations != null) {
                this.queryOperations = queryOperations;
            }

        }
        where(fieldPath: string | FieldPath, opStr: WhereFilterOp, value: any): IQuery {

            let queryOperation: QueryOperation = new QueryOperation();
            queryOperation.key = "where";
            queryOperation.fieldPath = fieldPath.toString();
            queryOperation.opStr = opStr;
            queryOperation.value = value;

            let query = new Query(this.path, this.queryOperations.concat([queryOperation]), this.httpMongo);


            return query;
        }

        orderBy(fieldPath: string | FieldPath, directionStr?: OrderByDirection): IQuery {

            let queryOperation: QueryOperation = new QueryOperation();
            queryOperation.key = "orderBy";
            queryOperation.fieldPath = fieldPath;
            queryOperation.directionStr = directionStr;

            let query = new Query(this.path, this.queryOperations.concat([queryOperation]), this.httpMongo);

            return query;
            //corrigir

            throw new Error("Method not implemented.  Query");
        }

        limit(limit: number): IQuery {


            let queryOperation: QueryOperation = new QueryOperation();
            queryOperation.key = "limit";
            queryOperation.limit = limit;
            let query = new Query(this.path, this.queryOperations.concat([queryOperation]), this.httpMongo);

            return query;
        }

        skip(index: number): IQuery {
            let queryOperation: QueryOperation = new QueryOperation();
            queryOperation.key = "skip";
            queryOperation.value = index;

            let query = new Query(this.path, this.queryOperations.concat([queryOperation]), this.httpMongo);

            return query;
        }


        startAt(...fieldValues: any[]): IQuery {


            let queryOperation: QueryOperation = new QueryOperation();
            queryOperation.key = "startAt";
            queryOperation.value = fieldValues[0];



            let query = new Query(this.path, this.queryOperations.concat([queryOperation]), this.httpMongo);


            return query;

        }
        startAfter(...fieldValues: any[]): IQuery {
            throw new Error("Method not implemented.  Query");
        }
        endBefore(...fieldValues: any[]): IQuery {
            throw new Error("Method not implemented.  Query");
        }
        endAt(...fieldValues: any[]): IQuery {
            throw new Error("Method not implemented.  Query");
        }
        isEqual(other: IQuery): boolean {
            throw new Error("Method not implemented.  Query");
        }
        get(options?: IGetOptions): Promise<IQuerySnapshot> {

            var promise = new Promise<IQuerySnapshot>(resolve => {

                this.httpMongo.getQuerySnapshot(this.path, this.queryOperations)
                    .then(result => {
                        resolve(new QuerySnapshot(result));
                    });


                //corrigir
            });

            return promise;
        }

        count(): Promise<number> {

            var promise = new Promise<number>(resolve => {

                this.httpMongo.getQueryCount(this.path, this.queryOperations)
                    .then(result => {
                        resolve(result);
                    });

            });

            return promise;
        }

        identificador: number = 0;
        onSnapshot(onNext: (snapshot: IQuerySnapshot) => void,
            onError?: (error: Error) => void,
            onCompletion?: () => void,
            maxElementsInFirstRequest?: number): () => void {

            let identificador = this.identificador++;

            //Bloco do Método local  threatChange/////
            /////////////////////////////////////////
            let threatChange = (change) => {


                if (change.operationType == 0)//Operação de inserção de um item na coleção
                {


                    this._documentData.push(change.fullDocument);

                    let documentData = this.applyQueryOperations();

                    if (this._previousFinalDocumentData == null || this._previousFinalDocumentData.length == 0 || documentData.length == 0) {
                        //se inseriu um documento em uma lista antes vazia passa pra frente
                        this._previousFinalDocumentData = { ...documentData };

                        onNext(new QuerySnapshot(documentData));
                    }
                    else {


                        if (this._previousFinalDocumentData.length != documentData.length ||
                            this._previousFinalDocumentData[0] != documentData[0]
                            || this._previousFinalDocumentData[this._previousFinalDocumentData.length - 1]
                            != documentData[documentData.length - 1]) { //se inseriu um documento a na lista final mudou o primeiro e ultimo elemento passa pra frente
                            this._previousFinalDocumentData = { ...documentData };

                            onNext(new QuerySnapshot(documentData));
                        }
                    }
                }
                else if (change.operationType == 1) // Operação de atualização de um elemento da coleção     
                {

                    if (this._documentData == null) {

                        throw new Error("Isso também nao deveria acontecer. Pensar numa implementação melhor pra essa situação 1");


                        this.httpMongo.getQuerySnapshot(this.path, this.queryOperations)
                            .then(data => {
                                this._documentData = data;
                                onNext(new QuerySnapshot(data));
                            });

                    }
                    else {


                        var index = this._documentData.findIndex(x => x._id == change.documentKey["_id"]);

                        if (index == null || index < 0) {

                            console.log("this._documentData",this._documentData);
                            throw new Error("Isso nao deveria acontecer. Pensar numa implementação melhor pra essa situação 2");

                            this.httpMongo.getQuerySnapshot(this.path, this.queryOperations)
                                .then(x => {
                                    onNext(new QuerySnapshot(x));
                                });

                        }
                        else {

                            this._documentData[index] = { ... this._documentData[index], ...change.updateDescription.UpdatedFields };

                            //No caso de um aupdate existem os campos removidos, que precisam ser retirados
                            for (let field in change.updateDescription.RemovedFields) {
                                delete this._documentData[index][change.updateDescription.RemovedFields[field]];
                            }

                            let documentData = this.applyQueryOperations();


                            this._previousFinalDocumentData = { ...documentData };

                            onNext(new QuerySnapshot(documentData));
                        }
                    }
                }

                else if (change.operationType == 2) {

                    var index = this._documentData.findIndex(x => x._id == change.documentKey["_id"]);

                    if (index == null || index < 0) {
                        this._documentData.push(change.fullDocument);
                    }
                    else {
                        this._documentData[index] = change.fullDocument
                    }

                    let documentData = this.applyQueryOperations();

                    this._previousFinalDocumentData = { ...documentData };

                    onNext(new QuerySnapshot(documentData));
                }
                else if (change.operationType == 3) {


                    var index = this._documentData.findIndex(x => x._id == change.documentKey["_id"]);


                    if (index >= 0) {


                        this._documentData.splice(index, 1);


                        let documentData = this.applyQueryOperations();

                        this._previousFinalDocumentData = { ...documentData };

                        onNext(new QuerySnapshot(documentData));
                    }
                    else {

                    }

                }
                else {
                    throw new Error("Method not implemented. chane operation " + change.operationType);
                }

                // Insert = 0,
                // Update = 1,
                // Replace = 2,
                // Delete = 3,
                // Invalidate = 4,
                // Rename = 5,
                // Drop = 6

            };
            //Fim do Bloco do Método local  threatChange/////
            /////////////////////////////////////////


            let countStart = 0;
            let started = false;

            let that = this;

            var changeListener = new ChangeListener(that.path, null, that.queryOperations, (change) => {



                if (change == null) {

                    started = true;
                    let queryOperations = that.queryOperations;
                    if (maxElementsInFirstRequest != null && maxElementsInFirstRequest > 0) {
                        let queryOperation = new QueryOperation();
                        queryOperation.key = "limit";
                        queryOperation.limit = maxElementsInFirstRequest;
                        that.queryOperations.push(queryOperation);
                    }

                    that.httpMongo.getQuerySnapshot(that.path, queryOperations)
                        .then(data => {
                            that._documentData = data;

                            that._previousFinalDocumentData = { ...data };
                            onNext(new QuerySnapshot(data));
                            that._previousChanges.forEach(previousChange => {
                                threatChange(previousChange);
                            });

                            countStart = 10;
                        });

                    return;
                }
                else if (that._documentData != null) {

                    threatChange(change);
                }

                if (countStart < 2) {

                    that._previousChanges.push(change);

                    if (that._previousChanges.length > 1000) {

                        countStart = 11;
                    }



                }
                else if (that._previousChanges.length != 0) {
                    that._previousChanges = [];
                }

            });


            that.httpMongo.addListener(changeListener);

            setTimeout(() => {

                if (!started) {

                    changeListener.Fire(null);

                }
                else {

                    countStart = 10;
                }
            }, 1000);

            return () => {
                that.httpMongo.removeListener(changeListener);

            };

        }

        applyQueryOperations() {
            if (this.queryOperations == null || this.queryOperations.length == 0) {
                return this._documentData;
            }

            let documentData = [...this._documentData];

            let count = 0;

            this.queryOperations.forEach(element => {
                switch (element.key) {
                    case "orderBy":
                        documentData.sort((a, b) => {
                            const valA = a[element.fieldPath.toString()];
                            const valB = b[element.fieldPath.toString()];

                            if (element.directionStr === "desc") {
                                if (valA < valB) return 1;
                                if (valA > valB) return -1;
                            } else {
                                if (valA < valB) return -1;
                                if (valA > valB) return 1;
                            }
                            return 0;
                        });
                        count++;
                        break;

                    case "startAt":
                        documentData = documentData.filter(x => x._id >= element.value);
                        count++;
                        break;

                    case "limit":
                        if (documentData.length > element.limit) {
                            documentData = documentData.slice(0, element.limit);
                        }
                        count++;
                        break;

                    case "skip":
                        if (documentData.length > element.value) {
                            documentData = documentData.slice(element.value);
                        }
                        count++;
                        break;

                    case "where":
                        if (element.opStr === '==') {
                            documentData = documentData
                                .filter(x =>
                                    ("" + x[element.fieldPath.toString()]).toLowerCase()
                                    === ("" + element.value).toLowerCase()
                                );
                        } else if (element.opStr === 'containsSimilar') {
                            if (element.value != null && element.value !== "") {
                                documentData = documentData
                                    .filter(x =>
                                        ("" + x[element.fieldPath.toString()]).toLowerCase()
                                            .indexOf((element.value).toLowerCase()) >= 0
                                    );
                            }
                        }
                        count++;
                        break;

                    default:
                        throw new Error("Operação não implementada: " + element.key);
                }
            });

            if (count < this.queryOperations.length) {
                throw new Error("Não foram implementadas algumas operações");
            }

            return documentData;
        }



    }

    export class SetOptions implements ISetOptions {

    }
    export class DocumentReference implements IDocumentReference {
        _documentData: DocumentData;
        _previousChanges: IChangeSnapshot[] = [];

        constructor(private _collectionPath: string, private _id: string, private httpMongo: WebApiConnectionService) {

        }

        get id(): string {
            return this._id;
        }
        get parent(): ICollectionReference {
            throw new Error("Method not implemented.  DocumentReference");
        }

        get path(): string {
            return this._collectionPath + "/" + this._id;
        }

        collection(collectionPath: string): ICollectionReference {

            //       console.log(this.path + "/" + collectionPath);
            //corrigir
            return new CollectionReference(this._collectionPath + "/" + this._id + "/" + collectionPath, this.httpMongo);
        }
        isEqual(other: IDocumentReference): boolean {
            throw new Error("Method not implemented.  DocumentReference");
        }
        set(data: DocumentData, options?: ISetOptions): Promise<void> {
            var setOptions: SetOptions = null;
            if (options != null) {
                throw new Error("Method not implemented. - É preciso resolver o SetOptions nao nulo");

                setOptions = Object.assign(options);
            }

            return this.httpMongo.setDocument(this.path, data).then();
        }

        setFields(data: DocumentData, options?: ISetOptions): Promise<void> {
            var setOptions: SetOptions = null;
            if (options != null) {
                throw new Error("Method not implemented. - É preciso resolver o SetOptions nao nulo");

                setOptions = Object.assign(options);
            }

            return this.httpMongo.setFieldsDocument(this.path, data).then();
        }

        delete(): Promise<void> {
            return this.httpMongo.deleteDocument(this.path).then();
        }
        get(options?: IGetOptions): Promise<IDocumentSnapshot> {
            return new Promise<IDocumentSnapshot>(resolve => {

                this.httpMongo.getDocumentSnapShot(this.path)
                    .then(documentSnapshot => {
                        resolve(new DocumentSnapshot(documentSnapshot));
                    });


            });
        }
        onSnapshot(onNext: (snapshot: DocumentSnapshot) => void, onError?: (error: Error) => void, onCompletion?: () => void): () => void {





            let threatChange = (change) => {

                if (this.path.indexOf("check") > 0) {
                    console.log("Entrou pra tratar " + this.path);
                }
                if (change.operationType == 0) {
                    this._documentData = change.fullDocument;
                    onNext(new DocumentSnapshot(this._documentData));
                }
                else if (change.operationType == 1) {
                    if (this._documentData != null) {

                        this._documentData = { ...this._documentData, ...change.updateDescription.UpdatedFields };

                        for (let field in change.updateDescription.RemovedFields) {
                            delete this._documentData[change.updateDescription.RemovedFields[field]];
                        }

                        onNext(new DocumentSnapshot(this._documentData));
                    }
                    else {
                        this.httpMongo.getDocumentSnapShot(this.path)
                            .then(documentData => {
                                this._documentData = documentData;
                                onNext(new DocumentSnapshot(documentData));

                            });
                    }
                }

                else if (change.operationType == 2) {
                    this._documentData = change.fullDocument;
                    onNext(new DocumentSnapshot(this._documentData));
                }
                else if (change.operationType == 3) {
                    onNext(new DocumentSnapshot(null));
                }
                else {
                    throw new Error("Method not implemented. chane operation " + change.operationType);
                }

                // Insert = 0,
                // Update = 1,
                // Replace = 2,
                // Delete = 3,
                // Invalidate = 4,
                // Rename = 5,
                // Drop = 6
            };

            let started = false;
            let countStart = 0;

            var changeListener = new ChangeListener(this._collectionPath, this._id, [], (change) => {


                if (change == null) {


                    started = true;
                    countStart++;

                    this.httpMongo.getDocumentSnapShot(this.path)
                        .then(documentData => {
                            this._documentData = documentData;

                            onNext(new DocumentSnapshot(documentData));

                            this._previousChanges.forEach(previousChange => {
                                threatChange(previousChange);
                            });
                        });

                    return;
                }
                //  else if (this._documentData != null) {

                threatChange(change);
                //   }

                if (countStart < 2) {
                    this._previousChanges.push(change);


                    // console.log("Entrou no armazenamento de documento que corrige o problemade sincronismo");
                    // console.log(this.path);
                    if (this._previousChanges.length > 1000) {
                        countStart = 11;
                    }
                }
                else if (this._previousChanges.length != 0) {
                    this._previousChanges = [];
                }

            });


            this.httpMongo.addListener(changeListener);

            setTimeout(() => {

                //console.log("setTimeout");

                if (!started) {
                    //console.log("!started");
                    changeListener.Fire(null);

                }
                else {

                    //console.log("started");
                    countStart = 10;
                }
            }, 1000);



            return () => {

                this.httpMongo.removeListener(changeListener);

            };
        }

    }
    export class CollectionReference extends Query implements ICollectionReference {


        delete(): Promise<any> {

            return this.httpMongo.deleteCollection(this.path).then();
        }

        constructor(public path: string, httpMongo: WebApiConnectionService) {
            super(path, null, httpMongo);
        }

        id: string;

        parent: IDocumentReference;

        doc(docId?: string): IDocumentReference {
            return new DocumentReference(this.path, docId, this.httpMongo);
        }
        add(data: DocumentData): Promise<IDocumentReference> {

            var promise = new Promise<DocumentReference>(resolve => {
                this.httpMongo.addDocument(this.path, data).then(
                    result => {

                        resolve(new DocumentReference(this.path, result.id, this.httpMongo))
                    }
                );
            });

            return promise;
        }






    }


}